import { PaymentElement, useElements } from "@stripe/react-stripe-js";
import React, { useEffect, useRef } from "react";

export default function StripePaymentElement({ handlers, options }) {
  const elements = useElements();
  const handlersRef = useRef(handlers);
  handlersRef.current = handlers;

  useEffect(() => {
    handlers.setPaymentElements(elements);

    return () => handlers.setPaymentElements(undefined);
  }, [elements, handlers]);

  // Resets readiness only on true unmount - eg. when the parent forces a remount via a key
  // change - so a stale "ready" flag can't outlive the element it describes. Depending on
  // `handlers` directly would re-fire this cleanup on every parent render, since `handlers`
  // is a new object each time; the ref keeps the callback current without that churn.
  useEffect(() => () => handlersRef.current.setPaymentElementReady(false), []);

  const onChange = (e) => {
    if (handlers.handleCardChange) {
      handlers.handleCardChange(e);
    }

    if (handlers.setCardError) {
      handlers.setCardError(null);
    }
  };

  const onReady = () => handlers.setPaymentElementReady(true);

  return (
    <div className="donation-form__payment-method" data-test="donation-form__stripe">
      <PaymentElement
        onChange={onChange}
        onReady={onReady}
        options={options}
      />
    </div>
  );
}
